/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Group_TrackersInputs */

const en_hub_group_trackers = /** @type {(inputs: Hub_Group_TrackersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trackers & task files`)
};

const id_hub_group_trackers = /** @type {(inputs: Hub_Group_TrackersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelacak & berkas task`)
};

/**
* | output |
* | --- |
* | "Trackers & task files" |
*
* @param {Hub_Group_TrackersInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_group_trackers = /** @type {((inputs?: Hub_Group_TrackersInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Group_TrackersInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_group_trackers(inputs)
	return en_hub_group_trackers(inputs)
});